import { createStyles } from 'antd-style'

import { AppIconsNames, colors } from './utils'

export const useIconStyles = createStyles(({ token }) => ({
  [AppIconsNames.Default]: token.colorPrimary,
  [AppIconsNames.FS]: colors.fs,
  [AppIconsNames.RocketDesigner]: colors.rocketDesigner,
  [AppIconsNames.CMS]: colors.cms,
  [AppIconsNames.Calendar]: colors.calendar,
  [AppIconsNames.Chat]: colors.chat
}))
